module.exports = __webpack_public_path__ + "img/schaumgeraete.a888d48.png";